<template>
  <div class="thrill-rides">
    <!-- Banner Section -->
    <Banner
      image="https://images.unsplash.com/photo-1592081491271-928eedff753f?q=80&w=2070&auto=format&fit=crop"
      title="Thrill Rides"
      height="700px"
    />

    <!-- Wavy Divider -->
    <div class="wave-container">
      <svg class="wave-top" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 400" preserveAspectRatio="none">
        <path class="wave-path" d="M0,96L40,106.7C80,117,160,139,240,154.7C320,171,400,181,480,165.3C560,149,640,107,720,90.7C800,75,880,85,960,112C1040,139,1120,181,1200,181.3C1280,181,1360,139,1400,117.3L1440,96L1440,400L1400,400C1360,400,1280,400,1200,400C1120,400,1040,400,960,400C880,400,800,400,720,400C640,400,560,400,480,400C400,400,320,400,240,400C160,400,80,400,40,400L0,400Z"></path>
      </svg>
    </div>

    <!-- Rides Section -->
    <div class="container">
      <h2>Extreme Thrill Rides</h2>
      <p>Experience the most exciting and heart-racing rides built for thrill seekers!</p>

      <div class="rides-grid">
        <div v-for="(ride, index) in thrillRides" :key="index" class="ride-card">
          <img :src="ride.image" :alt="ride.name" class="ride-image">
          <div class="ride-info">
            <h3>{{ ride.name }}</h3>
            <p>{{ ride.description }}</p>
            <span class="ride-duration">Duration: {{ ride.duration }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import Banner from "@/components/Banner.vue";

// Static Ride Data
const thrillRides = ref([
  {
    name: "The Cyclone Twister",
    description: "A high-speed water slide with unexpected twists and turns.",
    duration: "30 sec",
    image: "https://images.unsplash.com/photo-1505262981227-5551d18c1606?q=80&w=800",
  },
  {
    name: "Vertical Drop",
    description: "Experience an almost free-fall water slide at an extreme angle!",
    duration: "10 sec",
    image: "https://images.unsplash.com/photo-1570081324813-98397b874fed?q=80&w=800",
  },
  {
    name: "Wave Rider",
    description: "Get ready for extreme artificial waves that challenge your balance!",
    duration: "2 min",
    image: "https://images.unsplash.com/photo-1516295613457-9d021b0b37a3?q=80&w=800",
  },
  {
    name: "Rocket Blaster",
    description: "Blast through an enclosed water tunnel with high-speed acceleration!",
    duration: "20 sec",
    image: "https://images.unsplash.com/photo-1581641813709-6460771f93f3?q=80&w=800",
  },
]);
</script>

<style scoped>
/* 📌 Page Styling */
.thrill-rides {
  position: relative;
  background: white;
  margin-top: 700px;
}

/* 📌 Wave Effect */
.wave-container {
  position: absolute;
  top: -200px;
  left: 0;
  width: 100%;
  height: 220px;
  overflow: hidden;
}

.wave-top {
  position: absolute;
  bottom: -20px;
  left: 0;
  width: 100%;
  height: 100%;
  transform-origin: bottom;
  animation: waveFloat 5s ease-in-out infinite alternate;
}

.wave-path {
  fill: #ffffff;
  filter: drop-shadow(0px -2px 2px rgba(0, 0, 0, 0.1));
}

/* 📌 Container */
.container {
  text-align: center;
  padding: 30px 50px;
  margin-top: -1px;
}

h2 {
  color: #ff0000;
  font-size: 2rem;
  font-weight: bold;
  text-transform: uppercase;
  margin-top: 20px;
}

/* 📌 Rides Grid */
.rides-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 40px;
}

/* 📌 Ride Card */
.ride-card {
  background: #ffeded;
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.ride-card:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 15px rgba(255, 0, 0, 0.3);
}

.ride-image {
  width: 100%;
  height: 220px;
  object-fit: cover;
}

.ride-info {
  padding: 15px;
  text-align: left;
}

.ride-info h3 {
  color: #333;
  font-weight: bold;
}

.ride-info p {
  font-size: 14px;
  color: #666;
  margin: 10px 0;
}

.ride-duration {
  display: block;
  font-size: 12px;
  font-weight: bold;
  color: #ff0000;
}

/* 📌 Wave Animation */
@keyframes waveFloat {
  0% {
    transform: translateY(0) scaleY(1.02);
  }
  100% {
    transform: translateY(-10px) scaleY(1.05);
  }
}

/* 📌 Responsive Styling */
@media (max-width: 768px) {
  .wave-container {
    top: -150px;
    height: 170px;
  }

  .container {
    padding: 20px 30px;
  }
}

@media (max-width: 480px) {
  .wave-container {
    top: -100px;
    height: 120px;
  }

  .container {
    padding: 15px 20px;
  }
}
</style>
